export type LscErrorCode =
  | "BAD_MAGIC"
  | "UNSUPPORTED_VERSION"
  | "UNSUPPORTED_SUITE"
  | "BAD_HEADER"
  | "SIZE_MISMATCH"
  | "INTEGRITY_FAILED"
  | "TRAILING_DATA"
  | "LENGTH_MISMATCH"
  | "WRONG_PASSWORD_OR_CORRUPT"
  | "FRAGMENT_MISSING"
  | "BAD_FRAGMENT"
  | "BAD_INPUT"
  | "INPUT_OVERFLOW"
  | "INPUT_UNDERFLOW";

/**
 * All protocol-level failures are thrown as LscError with a stable machine-readable code.
 * UI layers map codes to localized messages; messages here are for developers only.
 */
export class LscError extends Error {
  readonly code: LscErrorCode;

  constructor(code: LscErrorCode, message?: string) {
    super(message ? `${code}: ${message}` : code);
    this.name = "LscError";
    this.code = code;
  }
}

export function isLscError(e: unknown, code?: LscErrorCode): e is LscError {
  return e instanceof LscError && (code === undefined || e.code === code);
}
